import { useState } from "react";

function InputBox({ onGenerate, loading }) {
  const [requirement, setRequirement] = useState("");
  const [useContext, setUseContext] = useState(true);

  const handleSubmit = () => {
    onGenerate(requirement, useContext);
  };

  return (
    <div className="bg-white p-4 rounded shadow">
      <textarea
        className="w-full border p-2"
        placeholder="Enter requirement..."
        value={requirement}
        onChange={(e) => {
    if (e.target.value.length <= 2000) {
      setRequirement(e.target.value);
        }
    }}
      />
      <p className="text-sm text-gray-500">
      {requirement.length} / 2000
      </p>

      <div className="flex items-center mt-2">
        <input
          type="checkbox"
          checked={useContext}
          onChange={() => setUseContext(!useContext)}
        />
        <label className="ml-2 text-sm">
          Use uploaded documents (RAG)
        </label>
      </div>

          <button
      onClick={() => onGenerate(requirement, useContext)}
      disabled={loading}
      className="bg-blue-600 text-white px-4 py-2 rounded"
    >
      {loading ? "Generating..." : "Generate"}
    </button>
    </div>
  );
}

export default InputBox;